import React from 'react';
import { Card } from './ui/card';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../mock';

export const Testimonials = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-[#F5F3F0] to-[#FAF9F7]">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-[#8B7D6B] font-montserrat text-sm tracking-[0.2em] uppercase mb-4">
            Customer Stories
          </p>
          <h2 className="text-4xl md:text-5xl font-seasons font-light text-[#2C2C2C] mb-6">
            Loved by Thousands
          </h2>
          <p className="text-[#8B7D6B] font-montserrat max-w-2xl mx-auto">
            Hear what our customers have to say about their experience with Sachdeva Sons
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {testimonials.map((testimonial) => (
            <Card
              key={testimonial.id}
              className="bg-white border-none shadow-md hover:shadow-xl transition-shadow duration-300 p-8 relative"
            >
              {/* Quote Icon */}
              <div className="absolute top-6 right-6 text-[#D4C4B0]">
                <Quote className="h-8 w-8" />
              </div>

              {/* Rating */}
              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className={`h-4 w-4 ${
                      i < Math.floor(testimonial.rating)
                        ? 'fill-[#C4B5A0] text-[#C4B5A0]'
                        : 'text-[#D4C4B0]'
                    }`}
                  />
                ))}
              </div>

              {/* Comment */}
              <p className="text-[#2C2C2C] font-montserrat leading-relaxed mb-6">
                "{testimonial.comment}"
              </p>

              {/* Customer Info */}
              <div className="border-t border-[#F5F3F0] pt-4">
                <p className="font-seasons text-lg text-[#2C2C2C] mb-1">{testimonial.name}</p>
                <p className="text-sm font-montserrat text-[#8B7D6B]">{testimonial.location}</p>
                <p className="text-xs font-montserrat text-[#C4B5A0] mt-1">{testimonial.date}</p>
              </div>
            </Card>
          ))}
        </div>

        {/* Trust Badges */}
        <div className="mt-20 pt-12 border-t border-[#D4C4B0]">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto text-center">
            <div>
              <div className="text-[#C4B5A0] mb-2">
                <svg className="h-8 w-8 mx-auto" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
              </div>
              <p className="text-sm font-montserrat text-[#2C2C2C] font-medium">4.8/5 Rating</p>
              <p className="text-xs font-montserrat text-[#8B7D6B]">2000+ Reviews</p>
            </div>
            <div>
              <div className="text-[#C4B5A0] mb-2">
                <svg className="h-8 w-8 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <p className="text-sm font-montserrat text-[#2C2C2C] font-medium">Verified Quality</p>
              <p className="text-xs font-montserrat text-[#8B7D6B]">100% Authentic</p>
            </div>
            <div>
              <div className="text-[#C4B5A0] mb-2">
                <svg className="h-8 w-8 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                </svg>
              </div>
              <p className="text-sm font-montserrat text-[#2C2C2C] font-medium">Secure Payment</p>
              <p className="text-xs font-montserrat text-[#8B7D6B]">COD Available</p>
            </div>
            <div>
              <div className="text-[#C4B5A0] mb-2">
                <svg className="h-8 w-8 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
                </svg>
              </div>
              <p className="text-sm font-montserrat text-[#2C2C2C] font-medium">Free Shipping</p>
              <p className="text-xs font-montserrat text-[#8B7D6B]">Above ₹2,999</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};